import { toast } from "sonner";
import { rowsByKindMap } from "@/lib/connectionRows";
import { SETTINGS_CONNECTION_KINDS } from "@/lib/channelRegistry";

export const CONNECTION_KINDS = SETTINGS_CONNECTION_KINDS;

export const OAUTH_ERROR_MESSAGES = {
  access_denied: "Google blocked sign-in — add your email as a test user in Google Cloud Console, or complete app verification for your domain",
  oauth_not_configured: "Google OAuth is not configured on this server",
  token_exchange_failed: "Google sign-in failed — try again",
  unknown_state: "Sign-in session expired — try again",
};

export function applyOauthRedirectFromUrl(fetchRows) {
  const params = new URLSearchParams(window.location.search);
  const connected = params.get("connected");
  const oauthError = params.get("error");
  if (connected !== "gmail" && connected !== "reddit" && connected !== "facebook"
      && connected !== "instagram" && connected !== "meta" && !oauthError) {
    return;
  }
  window.history.replaceState({}, "", "/settings/connections");
  if (connected === "gmail") {
    fetchRows().then(() => toast.success("Gmail and Google Calendar connected"));
  } else if (connected === "reddit") {
    fetchRows().then(() => toast.success("Reddit connected"));
  } else if (connected === "facebook" || connected === "meta") {
    fetchRows().then(() => toast.success("Facebook Page connected"));
  } else if (connected === "instagram") {
    fetchRows().then(() => toast.success("Instagram connected"));
  } else if (oauthError) {
    toast.error(OAUTH_ERROR_MESSAGES[oauthError] || `Sign-in failed (${oauthError})`);
  }
}

export async function seedMissingConnections(canEdit, fetchRows, setSeeding) {
  const existing = await fetchRows();
  const map = rowsByKindMap(existing);
  const missing = CONNECTION_KINDS.filter((c) => !map[c.kind]?.id);
  if (missing.length === 0 || !canEdit) {
    return;
  }
  setSeeding(true);
  const { connectionsApi } = await import("@/lib/api");
  for (const c of missing) {
    try {
      await connectionsApi.create(c.kind, { seeded_by: "settings_placeholder" });
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn(`seed ${c.kind} failed`, e?.message);
    }
  }
  await fetchRows();
  setSeeding(false);
}

export async function loadGoogleOauthStatus() {
  const { oauthApi } = await import("@/lib/api");
  return oauthApi.status();
}
